import { Component, Input, OnInit } from '@angular/core';
import { flatten } from '../../../utils/flatten';
import { SupplierService, TelephonyService } from '../../../services';
import { JobsService } from '../../../services';
import { IProfileJobInfo } from '../../../interfaces/telephony/profile-job-info';
import moment from 'moment';

@Component({
  selector: 'supplier-closed-jobs',
  templateUrl: './supplier-closed-jobs.component.html',
  styleUrls: ['./supplier-closed-jobs.component.scss'],
})
export class SupplierClosedJobsComponent implements OnInit {
  @Input() supplierId: number;
  @Input() supplierHomePos: any;
  @Input() impersonating: boolean;

  constructor(
    private jobService: JobsService,
    private supplierService: SupplierService,
    public telephonyService: TelephonyService,
  ) {}

  isLoading = true;
  jobs: IProfileJobInfo[];

  fromDate: Date;
  toDate: Date;
  jobFilterOptions = [
    { label: 'All', value: 0 },
    { label: 'Closed', value: 3 },
    { label: 'Cancelled', value: 4 },
  ];
  jobFilter = 0;
  viewedJobs: any; // used for filtering (defaults to _jobs)

  ngOnInit() {
    this.resetFilters();
  }

  loadJobs() {
    this.isLoading = true;

    // load closed/cancelled jobs in selected date range
    //console.log("Loading closed/cancelled jobs");
    let dto = {
      supplierId: this.supplierId,
      fromDate: moment(this.fromDate).format('YYYY-MM-DD'),
      toDate: moment(this.toDate).format('YYYY-MM-DD'),
      statuses: [3, 4], // closed, cancelled
    };

    this.jobService.getSupplierJobs(flatten(dto)).then((result) => {
      this.jobs = result;
      this.isLoading = false;
      this.jobFilterChanged();

      console.log('Closed/Cancelled Jobs: ', this.viewedJobs);
    });
  }

  jobFilterChanged() {
    if (this.jobFilter != 0) {
      this.viewedJobs = this.jobs.filter(
        (x) => x.tasks && x.tasks.length > 0 && x.statusId == this.jobFilter,
      );
    } else {
      this.viewedJobs = this.jobs;
    }
  }

  dateRangeChanged(event: any) {
    this.loadJobs();
  }

  resetFilters() {
    this.fromDate = moment().add('day', -28).toDate();
    this.toDate = moment().toDate();

    this.jobFilter = 0;

    // load closed jobs
    this.loadJobs();
  }
}
